import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom"; // For getting route params
import { API_TOKEN_NAME, IMAGE_URL } from "../../constants";
import Header from "../../component/frontend/Header";
import Footer from "../../component/frontend/Footer";
import banner_img from "../../images/banner-profile.jpg";
import inner_banner from "../../images/new_1.png";
import { Helmet } from "react-helmet";
import SEO from "../../component/Seo";
import backgroundImage from "../../images/background_image.jfif";
import { scAxiosAdmin } from "../..";

const style = {
  backgroundImage: `url(${backgroundImage}) no-repeat`,
  position: "relative",
};

const getSingleNewsEvents = (id) => {
  return new Promise((resolve, reject) => {
    const req = scAxiosAdmin.request("/newsevents/getsinglenewsevents/" + id, {
      method: "get",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
      },
    });
    req.then((res) => resolve(res.data)).catch((err) => reject(err));
  });
};

const SingleNewsEvents = () => {
  const { name } = useParams(); // Get the dynamic route parameter
  const [newsEvents, setNewsEvents] = useState({
    news_events_title: "",
    news_events_pic: "",
    news_events_desc: "",
  });
  const [videoLInk, setVideoLInk] = useState({});
  useEffect(() => {
    const getAllBanner = (data) => {
      try {
        const req = scAxiosAdmin
          .request("/settings/30", {
            method: "get",
          })
          .then((data) => {
            if (data.status === 200) {
              setVideoLInk(data.data.value);
            }
          })
          .catch((e) => {
            console.log("your log output", e);
          });
      } catch (error) {}
    };
    getAllBanner();
  }, []);
  const refreshgetSingleNewsEvents = () => {
    let new_news_event_title = name.replaceAll("-", " ");
    getSingleNewsEvents(name)
      .then((res) => {
        if (res.status === true) {
          var records = res.data;
          setNewsEvents({
            news_events_title: records.news_events_title,
            news_events_desc: records.news_events_desc,
            news_events_pic: records.news_events_pic,
          });
        } else {
          setNewsEvents({
            news_events_title: "",
            news_events_desc: "",
            news_events_pic: "",
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    refreshgetSingleNewsEvents();
  }, [name]); // Run this whenever the `name` parameter changes

  return (
    <div>
      <SEO
        title={
          newsEvents.news_events_title +
          " | United Hospital Bangladesh | Best Hospital In Bangladesh"
        }
        description={{ __html: newsEvents.news_events_desc }}
        pathSlug="/"
        keywords="newsevents, Singlenewsevents"
      />
      <Helmet>
        <meta
          name="description"
          content="United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
        />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "http://schema.org",
            "@type": "LocalBusiness",
            name: "United Hospital Limited",
            image:
              "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
            telephone: "10666",
            email: "info@uhlbd.com",
            address: {
              "@type": "PostalAddress",
              streetAddress: "plot 15, Road 71, Gulshan",
              addressLocality: "Dhaka",
              addressRegion: "Dhaka",
              addressCountry: "Bangladesh",
              postalCode: "1212",
            },
            openingHoursSpecification: {
              "@type": "OpeningHoursSpecification",
              opens:
                "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30",
            },
            url: "http://www.uhlbd.com/",
            aggregateRating: {
              "@type": "AggregateRating",
              ratingValue: "3.9",
              bestRating: "5",
              worstRating: "1",
              ratingCount: "756",
            },
            review: {
              "@type": "Review",
              author: {
                "@type": "Person",
                name: "abdul kahar",
              },
              datePublished: "2019-02-12",
              reviewRating: {
                "@type": "Rating",
                ratingValue: "3.9",
                bestRating: "5",
                worstRating: "1",
              },
              reviewBody:
                "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)",
            },
          })}
        </script>
      </Helmet>

      <Header />
      <div id="giveMargin" style={{ backgroundColor: "#fef3e9" }}>
        <section className="top-section">
          <img src={banner_img} alt="banner-profile" className="w-100" />
        </section>

        <section className="prof-dr">
          <div className="container">
            <div className="w-100 d-flex justify-content-center align-items-center flex-column py-4">
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  marginBottom: "10px",
                }}
              >
                <h3
                  className="text-center"
                  style={{
                    color: "#0C807D",
                    fontSize: "28px",
                    fontWeight: "500",
                  }}
                >
                  NEWS and EVENTS
                </h3>
              </div>
            </div>
            <h3
              className="text-center pb-4"
              style={{
                color: "#0C807D",
                fontWeight: "700",
                width: "100%",
              }}
            >
              {newsEvents.news_events_title}
            </h3>

            <div className="box-of-about mt-3 pb-4">
              <div
                className="row justify-content-between"
                style={{ width: "98%", margin: "0 auto" }}
              >
                <div
                  className="col-lg-8 pt-3"
                  style={{
                    border: "solid 1px #c5c5c5",
                    backgroundColor: "#fff",
                    borderRadius: "5px",
                  }}
                >
                  <div className="text-profile">
                    {newsEvents.news_events_pic ? (
                      <img
                        className="img-fluid img-thumbnail w-100"
                        style={{ objectFit: "cover" }}
                        src={
                          IMAGE_URL +
                          "NewsEventsImg/" +
                          newsEvents.news_events_pic
                        }
                        alt="banner-profile"
                      />
                    ) : (
                      <img
                        src={inner_banner}
                        alt="banner-profile"
                        className="w-100"
                      />
                    )}
                    <p
                      className="text-chnage mt-3"
                      dangerouslySetInnerHTML={{
                        __html: newsEvents.news_events_desc,
                      }}
                    ></p>
                  </div>
                </div>

                <div
                  className="col-lg-4 d-none d-md-block"
                  style={{
                    border: "solid 1px #c5c5c5",
                    backgroundColor: "#fff",
                    borderRadius: "5px",
                    width: "100%",
                    maxWidth: "350px",
                  }}
                >
                  <div
                    className="bookarea mt-3 d-none d-md-block mb-3"
                    style={{ position: "sticky", zIndex: "3333", top: 100 }}
                  >
                    <iframe
                      width="100%"
                      height="315"
                      src={videoLInk}
                      title="YouTube video player"
                      frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; muted"
                      allowfullscreen
                    ></iframe>
                    <h5
                      className="text-center p-2 text-light"
                      style={{
                        backgroundColor: "#0C807D",
                        marginTop: "-6px",
                      }}
                    >
                      Call Emergency Line
                      <br />
                      10666
                    </h5>
                    <img
                      src={"https://www.uhlbd.com/resources/images/contact.jpg"}
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <Footer />
    </div>
  );
};

export default SingleNewsEvents;



// WEBPACK FOOTER //
// ./src/component/frontend/singlenewsevents.js